import { createContext } from "react";

export const AppContext = createContext({
  postId: "",
  step: "START",
  points: 0,
  questionsCount: 0,
  questionsGenerator: {},
  changeStep() {},
  changePostId() {},
  addPoints() {},
});
